import { LineArrowLeft } from '@qr-front/icons/line-arrow-left'
import { CarouselDots } from '@qr-front/ui/components/Carousel'
import useEmblaCarousel, { UseEmblaCarouselType } from 'embla-carousel-react'
import { useAtomValue } from 'jotai'
import { useCallback, useEffect, useState } from 'react'

import {
	imageListAtom,
	imageLocalPreviewUrlsAtom,
} from '../../../contentFormSections'

const CarouselItem = ({ src }: { src: string }) => (
	<div className="flex justify-center px-5 [flex:0_0_100%]">
		<div className="rounded-4 bg-white p-[2px] shadow-generator">
			{/* eslint-disable-next-line @next/next/no-img-element */}
			<img alt="" src={src} className="max-h-80" />
		</div>
	</div>
)

export const ImageGallery = ({ hideOverlay }: { hideOverlay: () => void }) => {
	const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false })

	const [displayedImage, setDisplayedImage] = useState(0)
	const imageList = useAtomValue(imageListAtom)
	const localPreviewUrls = useAtomValue(imageLocalPreviewUrlsAtom)

	const count = Math.max(imageList.length, localPreviewUrls.length)
	const srcs = Array.from({ length: count }, (_, i) => {
		const cdnImage = imageList[i]
		if (cdnImage?.publicId) return `${cdnImage.bucketRootUrl}/${cdnImage.publicId}`
		return localPreviewUrls[i] ?? null
	}).filter((src): src is string => src !== null)

	const onSelect = useCallback((emblaApi: UseEmblaCarouselType[1]) => {
		if (emblaApi) {
			setDisplayedImage(emblaApi.selectedScrollSnap())
		}
	}, [])

	useEffect(() => {
		if (!emblaApi) {
			return
		}

		onSelect(emblaApi)

		emblaApi.on('reInit', onSelect).on('select', onSelect)
	}, [emblaApi, onSelect])

	return (
		<>
			<button
				onClick={hideOverlay}
				className="type-body-medium absolute left-5 top-6 flex items-center gap-2 text-dark-grey"
			>
				<LineArrowLeft className="size-4" />
				Back
			</button>
			<div className="absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2">
				<div ref={emblaRef} className="max-h-full overflow-hidden">
					<div className="hide-scrollbars flex max-h-full items-center py-2 [scrollbar-width:none]">
						{srcs.map((src, i) => (
							<CarouselItem key={i} src={src} />
						))}
					</div>
				</div>
				<div className="absolute -bottom-6 left-1/2 -translate-x-1/2 -translate-y-1/2">
					<CarouselDots
						current={displayedImage + 1}
						count={srcs.length}
						onClick={(index) => {
							emblaApi?.scrollTo(index)
						}}
					/>
				</div>
			</div>
		</>
	)
}
